/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { OrganizationApiConfiguration as __Configuration } from '../organization-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultClaimInfo } from '../models/list-query-result-claim-info';
@Injectable({
  providedIn: 'root',
})
class ClaimsService extends __BaseService {
  static readonly GetClaimsPath = '/api/claims';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Success
   */
  GetClaimsResponse(): __Observable<__StrictHttpResponse<ListQueryResultClaimInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/claims`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultClaimInfo>;
      })
    );
  }
  /**
   * @return Success
   */
  GetClaims(): __Observable<ListQueryResultClaimInfo> {
    return this.GetClaimsResponse().pipe(
      __map(_r => _r.body as ListQueryResultClaimInfo)
    );
  }
}

module ClaimsService {
}

export { ClaimsService }
